import {UserData} from 'components/customer/RoomPlanner/types';

type ShapeFlagSource = {userData?: Partial<UserData>} | null | undefined;

// L, Key and U shapes share the one trait placement cares about: an asymmetric
// footprint, so their bbox edge offsets change with rotation. Every clamp and
// snap path keys off this, so it lives in one place.
export const isNonRectShapeProduct = (group: ShapeFlagSource): boolean =>
    Boolean(
        group?.userData?.isLShapePanel ||
        group?.userData?.isKeyShapePanel ||
        group?.userData?.isUShapedPanel ||
        group?.userData?.hasUShapedShelves
    );

// A true L-shaped corner cabinet, as opposed to a flat L/Key/U wall panel.
// The kick panel rules take only the former as an L-shaped corner base.
export const isCornerLShapedCabinet = (group: ShapeFlagSource): boolean =>
    Boolean(group?.userData?.isLShapedProduct) && !isNonRectShapeProduct(group);
